import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import type { SFTPJob } from '@aigftpwatch/shared';

export function useSFTPStatus() {
  return useQuery({
    queryKey: ['sftp', 'status'],
    queryFn: () =>
      api.get<{ recentJobs: SFTPJob[]; pendingUploads: number }>('/sftp/status').then((r) => r.data),
    refetchInterval: 30_000,
  });
}

export function useSFTPJobs(page = 1) {
  return useQuery({
    queryKey: ['sftp', 'jobs', page],
    queryFn: () => api.getPaginated<SFTPJob>(`/sftp/jobs?page=${page}`),
  });
}

export function usePollNow() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/sftp/poll-now'),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['sftp'] });
      qc.invalidateQueries({ queryKey: ['inventory'] });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
